import React from "react";
export default function CardLoading({ visible }) {
	return (
		<div className={`overlay ${visible ? "" : "d-none" }`}>
				<i className="fas fa-5x fa-spinner fa-pulse" />
		</div>
	);
}